import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import FirstPagePdf from "./component/firstPage.pdf";
import RankTrackingProjectPdf from "./component/rankTrackingProject.pdf";
import TablePagePdf from "./component/tablePage.pdf";
import defaultLogo from "../../Assets/seoimg/logo.png";
import { LuCopyright } from "react-icons/lu";
import { getCurrentYear } from "../helper-js/current-year";
import useDynamicFont from "../custom-hook/useDynamicFont";

const CompetitorPdf = ({ table_data, whiteLabel }) => {
  const dynamicFontFamily = useDynamicFont("English");
  const first_page = {
    logo: whiteLabel?.logo?.src || defaultLogo,
    position: whiteLabel?.logo?.position || "flex-start",
    title: table_data.title,
  };

  const styles = StyleSheet.create({
    page: {
      fontFamily: dynamicFontFamily,
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      paddingTop: 35,
      paddingHorizontal: 35,
      paddingBottom: whiteLabel?.reset || whiteLabel?.footer ? 50 : 35,
    },
    footer: {
      fontSize: 11,
      height: "40px",
      textAlign: "center",
      color: "#FFFFFF",
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "#365486",
      display: "flex",
      justifyContent: "center",
      marginTop: 20,
    },
  });

  return (
    <Document>
      <FirstPagePdf data={first_page} />
      <Page size="A4" style={styles.page} wrap={true}>
        <View style={{ flex: 1 }}>
          <View
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 20,
              alignItems: whiteLabel?.reset
                ? "flex-start"
                : first_page.position,
            }}
          >
            <Image
              src={first_page.logo}
              style={{
                width: 150,
                height: "auto",
                objectFit: "contain",
                maxHeight: 80,
              }}
            />
          </View>
          <RankTrackingProjectPdf project_data={table_data} />
          <TablePagePdf data={table_data} />
        </View>
        {whiteLabel?.footer ? (
          <View style={styles.footer} fixed>
            <Text>
              <LuCopyright className="me-1 heading-medium" />
              {whiteLabel?.footer}
            </Text>
          </View>
        ) : null}
      </Page>
    </Document>
  );
};

export default CompetitorPdf;
